module.exports = __webpack_public_path__ + "img/bannera.d127a3b2.jpg";